import { render, staticRenderFns } from "./WorksShow.vue?vue&type=template&id=45c7c147&scoped=true"
import script from "./WorksShow.vue?vue&type=script&lang=js"
export * from "./WorksShow.vue?vue&type=script&lang=js"
import style0 from "./WorksShow.vue?vue&type=style&index=0&id=45c7c147&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c7c147",
  null
  
)

export default component.exports